import http from "@/http";
// 白名单
// 查询
export const getPlatform = {
  p: "/api/platform/list",
  r: data => {
    return http({
      url: "/api/platform/list",
      method: "post",
      data
    });
  }
};
// 删除
export const deletePlatform = {
  p: "/api/platform/delete",
  r: data => {
    return http({
      url: "/api/platform/delete",
      method: "post",
      data
    });
  }
};
// 修改
export const editPlatform = {
  p: "/api/platform/update",
  r: data => {
    return http({
      url: "/api/platform/update",
      method: "post",
      data
    });
  }
};
// 添加
export const addPlatform = {
  p: "/api/platform/add",
  r: data => {
    return http({
      url: "/api/platform/add",
      method: "post",
      data
    });
  }
};
